import { isBoolean } from 'lodash';
import { useMemo } from 'react';

type ValidationResult = boolean | { valid: boolean; reasons?: string[] };

interface UseValidationResult {
  isInvalid: boolean;
  errorMessage?: string;
}

export const useValidation = (
  validation?: ValidationResult,
): UseValidationResult => {
  return useMemo(() => {
    if (!isBoolean(validation) && !validation) {
      return { isInvalid: false, errorMessage: undefined };
    }

    if (isBoolean(validation)) {
      return { isInvalid: !validation, errorMessage: undefined };
    }

    return {
      isInvalid: !validation.valid,
      errorMessage: validation.reasons?.[0],
    };
  }, [validation]);
};
